module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.16.0_gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3_n2bs5ppwn25kvluj3aes4upwom/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/assets/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7eaff2967699616bd97a448df78ea263"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@18.3.1__dcdrwkunzx53zcajnsip7uirwm/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
